import { PersonEventCategory } from '../../models/person-event.model';

export type PersonEventEditorKind =
  | 'ministry'
  | 'ministry-change'
  | 'ministerial-activity'
  | 'appointment'
  | 'assignment'
  | 'activity'
  | 'religious-event';

export function parsePersonEventEditorKind(value: string | null): PersonEventEditorKind | null {
  if (
    value === 'ministry' ||
    value === 'ministry-change' ||
    value === 'ministerial-activity' ||
    value === 'appointment' ||
    value === 'assignment' ||
    value === 'activity' ||
    value === 'religious-event'
  ) {
    return value;
  }

  return null;
}

export function supportsPersonEventEditing(kind: PersonEventEditorKind): boolean {
  return kind === 'ministry-change' || kind === 'ministerial-activity' || kind === 'activity' || kind === 'religious-event';
}

export function getPersonEventCategoryForKind(kind: PersonEventEditorKind): PersonEventCategory | null {
  switch (kind) {
    case 'ministry-change':
    case 'ministerial-activity':
    case 'appointment':
      return 'MinisterialActivity';
    case 'activity':
      return 'Collaboration';
    case 'religious-event':
      return 'ReligiousEvent';
    default:
      return null;
  }
}

export function getPersonEventEditorErrorMessage(err: unknown, fallback: string): string {
  if (!err || typeof err !== 'object') {
    return fallback;
  }

  const error = err as {
    error?: { detail?: string; title?: string };
    response?: string;
    detail?: string;
    message?: string;
  };

  const friendlyValidationMessage = getFriendlyValidationMessage(
    error.error?.detail ?? error.detail ?? error.message ?? error.response
  );
  if (friendlyValidationMessage) {
    return friendlyValidationMessage;
  }

  if (error.error?.detail) {
    return error.error.detail;
  }

  if (error.detail) {
    return error.detail;
  }

  if (error.response) {
    try {
      const parsed = JSON.parse(error.response) as { detail?: string; title?: string };
      if (parsed.detail) {
        return parsed.detail;
      }
      if (parsed.title) {
        return parsed.title;
      }
    } catch {
      // Ignore parse errors.
    }
  }

  if (error.error?.title) {
    return error.error.title;
  }

  if (error.message && error.message !== 'An unexpected server error occurred.') {
    return error.message;
  }

  return fallback;
}

function getFriendlyValidationMessage(message?: string): string | null {
  if (!message) {
    return null;
  }

  if (message.includes('Dto.Areas') || message.includes('Dto Areas')) {
    return 'Para registrar la reactivación, agregá al menos un área de actividad.';
  }

  return null;
}

